module.exports = __webpack_public_path__ + "static/media/heroVid.e0e4ec3a.webm";